export const getPopupButtonLabel = (hasRoads = false, hasStations = false) => {
  if (hasRoads && hasStations) {
    return 'Шоссе и ж/д';
  } else if (hasRoads) {
    return 'Шоссе';
  } else if (hasStations) {
    return 'Ж/д';
  } else {
    return '';
  }
};
